<template>
  <div class="table-wrapper">
    <h1 style="text-align: center">收入成本确认表</h1>
    <div class="table-title">
      <p>项目名称：{{ detail.projectName }}</p>
      <p>{{ detail.createTime }}</p>
      <p>单位：元</p>
    </div>
    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :span-method="spanArrayMethod"
        height="500"
      >
        <el-table-column
          prop="myindex"
          label="行次"
          width="50"
        ></el-table-column>
        <el-table-column label="项目">
          <el-table-column prop="title1" label=""></el-table-column>
          <el-table-column prop="title2" label=""></el-table-column>
        </el-table-column>
        <el-table-column label="金额">
          <template slot-scope="scope">
            <div>{{ formatNumberDisplay(scope.row) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
      </el-table>
      <div style="text-align: right">
        <p style="margin-right: 100px">制表：</p>
      </div>
    </div>

    <div class="page-bottom-control">
      <!-- for test -->
      <!-- <span>approveStatus:{{approveStatus}}</span> -->
      <el-button
        v-if="approveStatus && approveStatus != 2"
        type="primary"
        @click="previewHandler"
        :loading="previewBtnLoading"
        >打印</el-button
      >
      <el-button type="primary" @click="exportData">导出</el-button>
      <el-button type="info" @click="closePage">关闭</el-button>
    </div>

    <el-dialog
      title="预览"
      :visible="dialogVisible"
      width="80%"
      @close="dialogClosed"
    >
      <div id="earningCostCheckTablePrint">
        <h1 style="text-align: center">收入成本确认表</h1>
        <div>
          <p>项目名称：{{ detail.projectName }}</p>
          <p>{{ detail.createTime }}</p>
          <p>单位：元</p>
        </div>
        <div>
          <table
            style="
              width: 100%;
              border: 1px solid black;
              table-layout: fixed;
              border-collapse: collapse;
            "
          >
            <thead>
              <tr style="text-align: left; border-bottom: 1px solid black">
                <th
                  rowspan="1"
                  style="
                    border-right: 1px solid black;
                    width: 100px;
                    box-sizing: border-box;
                  "
                >
                  <div style="padding: 12px 4px">行次</div>
                </th>
                <th
                  rowspan="1"
                  colspan="2"
                  style="
                    border-right: 1px solid black;
                    width: 400px;
                    box-sizing: border-box;
                  "
                >
                  <div style="padding: 12px 4px">项目</div>
                </th>
                <th rowspan="1" style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">金额</div>
                </th>
                <th rowspan="1" style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">备注</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style="border-bottom: 1px solid black">
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  rowspan="12"
                >
                  <div>1</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  rowspan="12"
                >
                  <div>预算金额</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>合同金额</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatMoneyNumber(detail.projectAmount) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>暂定金金额</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatMoneyNumber(detail.provisionalAmount) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>合同变更额</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatMoneyNumber(detail.changeAmount) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>清单复核金额</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatMoneyNumber(detail.listCheckAmount) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>合同物价指数金额</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{ formatMoneyNumber(detail.contractPriceIndexAmount) }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>审计金额</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatMoneyNumber(detail.auditAmount) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>收入确认基数</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatMoneyNumber(detail.earningCheckBase) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>预计合同总收入</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatMoneyNumber(detail.expectEarningAmount) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>比例</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatPercentNumber(detail.expectIncomePct) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>预计可实现收入</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatMoneyNumber(detail.expectIncome) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>预计合同总成本</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatMoneyNumber(detail.expectCostAmount) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>预计合同总毛利</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatMoneyNumber(detail.expectProfitAmount) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>2</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>实际成本</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>期末累计发生实际成本</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatMoneyNumber(detail.endActCost) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>3</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>完工百分比</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ formatPercentNumber(detail.finishPct) }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <!-- 4 -->
              <tr style="border-bottom: 1px solid black">
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  rowspan="3"
                >
                  <div>4</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  rowspan="3"
                >
                  <div>累计应确认</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>合同收入（主营业务收入）</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.alreadyTotalCheck
                          ? detail.alreadyTotalCheck.earningAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>合同费用（主营业务成本）</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.alreadyTotalCheck
                          ? detail.alreadyTotalCheck.costAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>合同毛利</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.alreadyTotalCheck
                          ? detail.alreadyTotalCheck.profitAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <!-- 5 -->
              <tr style="border-bottom: 1px solid black">
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  rowspan="3"
                >
                  <div>5</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  rowspan="3"
                >
                  <div>以前已确认</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>合同收入（主营业务收入）</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.historyCheck
                          ? detail.historyCheck.earningAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>合同费用（主营业务成本）</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.historyCheck ? detail.historyCheck.costAmount : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>合同毛利</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.historyCheck
                          ? detail.historyCheck.profitAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <!-- 6 -->
              <tr style="border-bottom: 1px solid black">
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  rowspan="3"
                >
                  <div>6</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  rowspan="3"
                >
                  <div>当期应确认</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>合同收入（主营业务收入）</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.currentCheck
                          ? detail.currentCheck.earningAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>合同费用（主营业务成本）</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.currentCheck ? detail.currentCheck.costAmount : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>合同毛利</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.currentCheck
                          ? detail.currentCheck.profitAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h2 style="margin-top: 15px">审批信息</h2>
          <div>
            <table
              style="
                width: 100%;
                border: 1px solid black;
                table-layout: fixed;
                border-collapse: collapse;
              "
            >
              <thead>
                <tr style="text-align: left; border-bottom: 1px solid black">
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">序号</div>
                  </th>
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">员工名称</div>
                  </th>
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">岗位名称</div>
                  </th>
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">相关意见</div>
                  </th>
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">当前状态</div>
                  </th>
                  <th>
                    <div style="padding: 12px 4px">时间</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-if="approveData && approveData.length > 0">
                  <tr
                    v-for="(item, index) in approveData"
                    :key="index"
                    style="border-bottom: 1px solid black"
                  >
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div>
                        {{ index + 1 }}
                      </div>
                    </td>

                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div>
                        {{ item.approveUserName }}
                      </div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div>
                        {{ item.jobName }}
                      </div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div>
                        {{ item.opinion }}
                      </div>
                    </td>
                    <td style="padding: 12px 4px">
                      <div>
                        {{ item.statusName }}
                      </div>
                    </td>
                    <td style="padding: 12px 4px">
                      <div>
                        {{ item.updateTime }}
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr style="border-bottom: 1px solid black">
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="page-bottom-control">
        <el-button type="primary" @click="printHandler">打印</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatMoney, formatPercent } from "./utils";
import { formatEarningCostCheckTableData } from "./EarningHelper";
import printJS from "print-js";
import { queryApproveHistoryApi } from "../../services/financeService";
import Constants from "../../utils/consts";
//---------
//收入成本管理-查看收入记录-收入成本确认表
//-------
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    id: {
      type: [String, Number],
      default: "",
    },
    approveStatus: {
      type: [String, Number],
      default: "",
    },
    closefn: {
      type: Function,
    }
  },
  computed: {
    tableData: function () {
      return formatEarningCostCheckTableData(this.detail);
    },
  },
  data() {
    return {
      dialogVisible: false,
      previewBtnLoading: false,
      approveData: [],
    };
  },
  methods: {
    formatMoneyNumber: formatMoney,
    formatPercentNumber: formatPercent,
    formatNumberDisplay(rowData) {
      if (rowData.isPct) {
        return rowData.data; //  后台返回的是已经处理好的字符串形式
      }
      return formatMoney(rowData.data);
    },
    spanArrayMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0 || columnIndex == 1) {
        return {
          rowspan: row.rowspan,
          colspan: 1,
        };
      }
    },
    exportData() {
      //:导出收入成本确认表
      console.log("导出收入成本确认表", this.detail);
      this.$emit("export-click", 1);
    },
    previewHandler() {
      this.previewBtnLoading = true;
      queryApproveHistoryApi({
        approveClass: "EARNING_COST",
        itemId: this.id,
      })
        .then((res) => {
          console.log("----回报", res);
          if (res.code == Constants.Code_OK) {
            this.approveData = res.data || [];
            setTimeout(() => {
              this.dialogVisible = true;
            }, 0);
          } else {
            this.previewBtnLoading = false;
          }
        })
        .catch((error) => {
          console.log("----error", error);
          this.previewBtnLoading = false;
        });
    },
    dialogClosed() {
      this.dialogVisible = false;
      this.previewBtnLoading = false;
    },
    printHandler() {
      printJS({
        printable: "earningCostCheckTablePrint",
        type: "html",
        targetStyles: ["*"],
        ignoreElements: ["no-print", "bc", "gb"],
        scanStyles: false,
      });
    },
    closePage() {
      if(this.closefn) {
        this.closefn()
        return;
      }
      this.bus.$emit("tabClose", "incomingConstDetail");
      this.bus.$emit("navMenuChange", {
        routeId: "incomeConstList",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table-wrapper {
  padding: 16px;
}

.page-bottom-control {
  text-align: center;
  padding: 20px 0;
}
</style>
